(function(angular) {

  var LikesService = function($window) {
    var likes = [];
    return {
      get: function() {
        return likes;
      },
      has: function(id) {
        return ~likes.indexOf(id);
      },
      find: function(id) {
        return likes.indexOf(id);
      },
      add: function(val) {
        likes.push(val);
        this.commit();
      },
      remove: function(key) {
        likes.splice(key, 1);
        this.commit();
      },
      toggle: function(id) {
        var key = this.find(id);
        if (~key) {
          this.remove(key);
        } else {
          this.add(id);
        }
      },
      update: function(data) {
        var _likes = [];

        angular.forEach(data, function(val, key) {
          _likes.push(val.uid);
        });

        likes = _likes;
        this.commit();
        this.notify();
      },
      commit: function() {
        $window.localStorage.likes = $window.JSON.stringify(likes);
      },
      notify: function() {
        angular.element('.favorites__number').
            find('.value').
            text(likes.length);
      },
      load: function() {
        likes = $window.localStorage.likes ? ($window.JSON.parse(
            $window.localStorage.likes) || []) : [];
      },
    };
  };

  angular.module('ins.models').factory('likes', LikesService);
})(window.angular);